import '@mdi/font/css/materialdesignicons.css';
import Vue from 'vue';
import Vuetify, {
  VAlert,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VToolbar,
  VDataTable,
  VProgressLinear,
  VBadge
} from 'vuetify/lib';

// vue-cli a-la-carte installation
Vue.use(Vuetify, {
  components: {
    VAlert,
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VToolbar,
    VDataTable,
    VProgressLinear,
    VBadge
  },
});

const opts = {
  theme: {
    themes: {
      light: {
        primary: '#0b5596',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#e6001c',
        info: '#2196F3',
        success: '#4CAF50',
        danger:'#e6001c'
      },
      // dark: {
      // }
    },
  },
};

export default new Vuetify(opts);
